import script from "./TicPatientMobileCard.vue?vue&type=script&setup=true&lang=js"
export * from "./TicPatientMobileCard.vue?vue&type=script&setup=true&lang=js"

import "./TicPatientMobileCard.vue?vue&type=style&index=0&id=38cf41af&scoped=true&lang=css"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-38cf41af"]])

export default __exports__